export function registerInitialTransports(faro) {
    faro.transports.add(...faro.config.transports);
    faro.transports.addBeforeSendHooks(faro.config.beforeSend);
}
//# sourceMappingURL=registerInitial.js.map